import { getGlobalMapToken } from '@umu/design-base';
import _get from 'lodash/get';
import { ThemeConfigData } from './themeConfigConst';
import { $window } from '@umu/umu-dom';

export const defaultSystemThemeColor = '#fab400';
export const defaultSystemTextColor = '#222222';

export const defaultSystemThemeConfig: ThemeConfigData = {
    type: 'default',
    token: getGlobalMapToken({
        colorPrimary: defaultSystemThemeColor,
        colorText: defaultSystemTextColor,
    }),
};

export const getSystemThemeConfig = (): ThemeConfigData => {
    return _get($window, 'pageData.config.theme_config', defaultSystemThemeConfig);
};

export const getCurrentThemeColor = (): string => {
    return _get($window, 'pageData.config.theme_config.token.colorPrimary', defaultSystemThemeColor);
};
